import React, { useEffect } from 'react';
import { Error500 } from '@components/common/hero/error/Error500';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { GetStaticProps } from 'next';
import { PageProps } from '@model/pages';
import { ContentApi } from '@model/iceberg';
import { PageTemplates } from '@model/content';
import { TripTypes } from '@model/common';
import { setTripTypeFilter } from '@state/slices/navigation';
import { useDispatch } from 'react-redux';
import { Revalidate } from '@model/config/revalidate';
import { ERROR_CODES } from '@model/common/error-codes';
import { PageConfig } from '@model/content';
import { getStaticPropsTripTypes } from '@layout/get-page-props';
import { GenericPageLayout } from '@layout/GenericPageLayout';
import { Logging } from '@util/logging';

/* ***************** *
 *       Types       *
 * ***************** */
export interface TripTypeLandingPageProps extends PageProps {
  path: string;
  tripType: TripTypes;
  pageConfig: PageConfig;
  componentsData: Array<any>;
}

/* ************************* *
 *    TripTypeLandingPage    *
 * ************************* */
const TripTypeLandingPage = ({
  path,
  pageConfig,
  tripType,
  promoBannerTripType,
  componentsData
}: TripTypeLandingPageProps) => {
  if (!pageConfig) {
    Logging.warn({ text: `No pageConfig for ${path} ${tripType}` });
    return <Error500 code={ERROR_CODES.NO_CMS_CONFIG} />;
  }

  const { components } = pageConfig;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setTripTypeFilter(tripType));
  }, []);

  return (
    <GenericPageLayout
      components={components}
      tripType={tripType}
      path={path}
      promoBannerTripType={promoBannerTripType}
      componentsData={componentsData}
    />
  );
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async ({ res, params }: any) => ({
  ...(await getStaticPropsTripTypes({ store, res, query: params })),
  revalidate: Revalidate.HALF_HOUR
}));

export async function getStaticPaths() {
  const tripTypePages = await new ContentApi().getPageConfigMap({ template: PageTemplates.TRIP_TYPE_PAGE });
  const paths = tripTypePages.map(({ path }) => `/${path}`);

  return { paths, fallback: false };
}

export default withGlobalProvider(TripTypeLandingPage);
